import React, { useState } from "react";

import ArrowRightIcon from "images/icons/arrow-right-icon.inline.svg";
import TimeCircleSvg from "images/icons/time-circle.inline.svg";

import { useTheme } from "../../../context/ThemeContext";
import { useProgramFees } from "../../../hooks/useProgramFees";
import { useProgramTitles } from "../../../hooks/useProgramTitles";
import { Link } from "../../../utils/customLink";
import { renderCurrencyDateImage } from "../../../utils/formatContent";
import { shortcodePreProcessor } from "../../../utils/formatContent";
import Image from "../../image";

const BlogStickyFooter = ({
  footerImage,
  footerTitle,
  footerSubtitle,
  footerCtaTitle,
  post,
  cardBookDesc,
  enquireBtn = true,
  enquireNowLink = "/enquiry-form/",
  enquireNowCtaTitle = "Enquire",
  applicationFormLink = "/application-form/",
  allowCookieControl = true,
  cookieName = "isPromoStickyFooterShow",
  displayCloseButton = true,
  contentContainerClass = "sm:w-1/4",
  cardBookDescSpanClass = "text-xs font-semibold text-left sm:font-normal dark:text-white text-generic-text",
  footerTitleClass = "text-xl font-normal dark:font-light dark:text-white text-black-lighter font-alice dark:font-body",
  footerSubtitleClass = "dark:text-white text-black-lighter"
}) => {
  const [showSticky, setShowSticky] = useState(
    (allowCookieControl === false
      ? true
      : typeof window !== "undefined" &&
        window.localStorage.getItem("isPromoStickyFooterShow")) ?? true
  );

  const handleCloseSticky = () => {
    setShowSticky(false);

    if (allowCookieControl)
      if (typeof window !== "undefined") {
        window.localStorage.setItem("isPromoStickyFooterShow", false);
      }
  };

  const { currentSiteMeta, currentBrand } = useTheme();

  const dateStrFormat = "";

  const programFees = useProgramFees() || [];
  const programSubtitles = useProgramTitles() || "";
  const datesCostSubtitle = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: programSubtitles?.datesCostsSubtitle || ""
  });

  const formattedFooterDesc = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: cardBookDesc || ""
  });

  const formattedFooterTitle = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: footerTitle || ""
  });

  const formattedFooterSubtitle = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: footerSubtitle || ""
  });

  const { currency } =
    currentSiteMeta ?? process.env.GATSBY_PROJECT_CURRENCY ?? "gbp";
  const currencyToUse = currency
    ? currency.toLowerCase()
    : process.env.GATSBY_PROJECT_CURRENCY ?? "gbp";
  const showPricingExtra = datesCostSubtitle && currencyToUse === "gbp";

  // console.log("showPricingExtra", {
  //   datesCostSubtitle,
  //   cardBookDesc,
  //   footerTitle,
  //   footerSubtitle
  // });
  return (
    <>
      {showSticky === true && (
        <div className="container mx-auto z-50">
          <div className="flex items-center justify-between gap-4 footer-content h-[113px] py-2">
            <div className="relative w-1/5 h-full">
              {footerImage && (
                <Image
                  imageAlt="Blog Footer"
                  image={""}
                  imageClass="absolute bottom-0 left-0 w-full bg-center bg-cover  object-cover object-center"
                  sourceUrl={footerImage}
                />
              )}
            </div>
            <div className={`footer-content__text ${contentContainerClass}`}>
              {footerTitle && (
                <div
                  className={footerTitleClass}
                  dangerouslySetInnerHTML={{
                    __html: formattedFooterTitle
                  }}
                />
              )}

              {footerSubtitle && (
                <div
                  className={footerSubtitleClass}
                  dangerouslySetInnerHTML={{
                    __html: formattedFooterSubtitle
                  }}
                />
              )}

              {!showPricingExtra && cardBookDesc && (
                <div className="flex w-full py-3 rounded-full sm:py-2 gap-2 items-center">
                  <TimeCircleSvg className="w-6 h-6 dark:sm:w-5 dark:sm:h-5 dark:gvi-text-green text-tertiary-bg fill-yellow-lighten dark:fill-green-standard" />
                  <span
                    className={cardBookDescSpanClass}
                    dangerouslySetInnerHTML={{
                      __html: `${formattedFooterDesc} ${dateStrFormat}`
                    }}
                  />
                </div>
              )}

              {showPricingExtra && (
                <div className="w-full flex py-2 items-center gap-2">
                  <Image
                    imageAlt={""}
                    image={""}
                    imageClass="inline-block w-5"
                    sourceUrl={renderCurrencyDateImage({
                      currentSiteMeta,
                      currentBrand
                    })}
                  />
                  <div
                    className="desc font-body text-xs dark:text-white text-generic-text font-bold"
                    dangerouslySetInnerHTML={{ __html: datesCostSubtitle }}
                  />
                </div>
              )}
            </div>
            <div className="flex justify-center w-1/3 gap-1">
              {enquireBtn && (
                <Link
                  to={enquireNowLink}
                  className="flex m-auto w-full py-2 px-4 bg-white dark:bg-black-light border border-black-lighter dark:border-white justify-center items-center rounded-full dark:rounded-xxs"
                >
                  <span className="text-base pl-2 mr-2 font-bold !text-black-lighter dark:!text-white tracking-[0.02em]">
                    {enquireNowCtaTitle}
                  </span>
                  <ArrowRightIcon className="stroke-black-lighter dark:stroke-white" />
                </Link>
              )}
              {applicationFormLink && (
                <Link
                  to={applicationFormLink}
                  className="flex m-auto  w-full py-2 px-4 bg-red-light dark:bg-green-standard justify-center items-center rounded-full dark:rounded-xxs"
                >
                  <span className="text-base pl-2 mr-2 font-bold !text-white dark:!text-gray-darker tracking-[0.02em]">
                    {footerCtaTitle}
                  </span>
                  <ArrowRightIcon className="stroke-white dark:stroke-gray-darker" />
                </Link>
              )}
            </div>

            {displayCloseButton && (
              <div className="relative w-6 h-6" onClick={handleCloseSticky}>
                <div className="absolute bg-white rounded-full w-6 h-6 block close-icon before:top-[4px] after:top-[4px]" />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BlogStickyFooter;
